import React from "react";
import style from "./style.module.css"
function index({ title }) {
  return (
    <div className={style.container}>
        <h1 className={style.title}>{title}</h1>
      <table className={style.table}>
        <tbody className={style.tbody}>
          <tr>
            <td>Immob</td>
            <td>235 Annonces</td>
          </tr>
          <tr>
            <td>Immobilier à Maarif</td>
            <td>235 Annonces</td>
          </tr>
          <tr>
            <td>Location de studios à Casablanca</td>
            <td>235 Annonces</td>
          </tr>
          <tr>
            <td>Location de maisons et villas à Casablanca</td>
            <td>235 Annonces</td>
          </tr>
          <tr>
            <td>Location de locaux commerciaux et magasins à Casablanca</td>
            <td>235 Annonces</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default index;
